// extracted by mini-css-extract-plugin
module.exports = {"container":"SpwTopupModal_container__1VriD","title":"SpwTopupModal_title__3gXf-","footer":"SpwTopupModal_footer__2-eBq","button":"SpwTopupModal_button__3k9A2"};